

















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Analysis } from "@/api/analyses/types";
import { FarmAnalysisResult } from "@/api/results/types";
import CropIcons from "@/utils/iconCropTypes";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import YieldChart from "../yield-chart/YieldChart.vue";
import { formattedAreaInHa } from "@/filters/area";
import { percentFilter, percentAsIsFilter } from "@/filters/percent";
import { formattedYield, formattedProduction } from "@/filters/yield";
import { roundedWithFrac } from "@/filters/scalar";
import i18n from "@/i18n";
import Icon from "@/components/agroIcons/AgroIcons.vue";

@Component({
  name: "ResultSummary",
  components: {
    Icon,
    AgroIcons,
    YieldChart,
  },
  filters: {
    formattedAreaInHa,
    formattedYield,
    formattedProduction,
    percentFilter,
    percentAsIsFilter,
    roundedWithFrac,
    formattedDate(value: Date) {
      if (!value) {
        return "";
      } else {
        const dateAux = new Date(value);
        dateAux.setUTCMinutes(
          dateAux.getUTCMinutes() + dateAux.getTimezoneOffset()
        );
        return i18n.d(dateAux, "short");
      }
    },
  },
})
export default class ResultSummary extends Vue {
  @Prop({ type: Object, required: true })
  private result!: FarmAnalysisResult;

  @Prop({ type: Object, required: true })
  private analysis!: Analysis;

  @Prop({ type: String, default: "" }) 
  private source?: string;

  private formatScore(score: string) {
    return parseInt(score.split("_")[1], 10);
  }

  get production() {
    return this.result.averageYield * this.result.cropArea;
  }
  
  get version() {
    return `${this.$t('info-tooltip.version.version-label')}
  - ${this.$t('info-tooltip.version.pipeline-label')}: ${this.result.pipelineVersion}
  - ${this.$t('info-tooltip.version.crop-id-label')}: ${this.result.cropIdVersion}
  - ${this.$t('info-tooltip.version.yieldest-label')}: ${this.result.yieldestVersion}`
  }

  get arablePercentage() {
    return this.analysis.farmArea
      ? this.result.arableArea / this.analysis.farmArea
      : 0.0;
  }

  get cropPercentage() {
    return this.analysis.farmArea
      ? this.result.cropArea / this.analysis.farmArea
      : 0.0;
  }

  get verifyCropPercentAndCropArea() {
    return this.cropPercentage > 0.05 && this.result.cropArea > 0;
  }

  private get cropTypeIconName() {
    return CropIcons.fromText(this.result.cropType);
  }
}
